import Compressor from 'compressorjs';
import { catCICACReasonRejection } from './MochaData'

const GetNewGuid = (type: number = 0) => {
    if (type === 1)
        return 'xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r: number = Math.random() * 16 | 0;
            const v: number = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
        const r: number = Math.random() * 16 | 0;
        const v: number = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

const RoundToTwo = (value: number, decimals = 2): number => (Number(Math.round(parseFloat(value.toString() + 'e' + decimals)) + 'e-' + decimals));

const ValidData = (data: string) => (data !== null && data !== undefined && data !== '')

const GetDataEnte = (data: IAutoEmisionCR) => {
    let ente = {
        TipoId: data.typeDocument,
        NumId: data.identification,
        Nacionalidad: data.nationality,
        Sexo: data.sex,
        FechaNacimiento: data.birthdate,
        Profesion: data.profession,
        Direccion: data.address,
        EstadoCivil: data.civilStatus,
        PaisOrigen: data.countryOfOrigin,
        Departamento: data.province,
        Municipio: data.district,
        Distrito: data.canton,
        CasaPropia: data.ownHouse === 'S' ? true : false,
        TieneHijos: data.haveChildren === 'S' ? true : false,
        VehiculoPropio: data.ownVehicle === 'S' ? true : false,
        TelefonoCasa: data.homePhone,
        //Actividad: data.actividad,
        //Ocupacion: data.ocupacion,
        //OrigenFondos: data.origenFondo,
        EmpreLab: data.company,
        IngresoMensual: data.monthlyIncome,
        //TelefonoEmp: data.telefono,
        CMonedaIngresos: "U$",
        //"": data.ingresoMoneda
        "NombreConyuge": `${data.spouseName} ${data.spouseLastName}` // ambos nombres
    }
    return ente;
}

const BuilDataToUpdate = (data: IAutoEmisionCR) => {
    const oaTemp = {
        auChasis: data.vehicleChasis,
        auPlaca: data.vehiclePlate,
        auVin: data.vehicleChasis,
        auMotor: data.vehicleEngine,
        auColor: data.vehicleColor,
        auNoPuertas: data.vehicleDoorNumber,
        auClaseveh: data.vehicleClass,
        auCombustible: data.vehicleFuel,
        auTipoTransmision: data.vehicleTransmission,
        auCilindros: data.vehicleCylinderNumber
    }
    const pol = {
        id: data.idPol,
        au: oaTemp,
        DateIsModified: true,
        FechaDesde: formatDate(data.autoInsuranceStartDate?.toString())
    }

    return pol
}

const formatDate = (value: string | undefined) => (value === '' || value === undefined )? null : new Date(value).toDateString();

const BuildPayment = (data: IAutoEmisionCR) => {
    return {
        policyId: data.idPol,
        cardHolder: data.cardName,
        cardNumber: data.cardNumber,
        cvv: data.cardCVV,
        expirationDate: data.cardExpirationDate,
        amountApp: data.feePay,
        currencyApp: GetCurrecyPV(data.currencyPlan),
        email: data.insuredMail
    }
}

const BuildSaveCard = (data: IAutoEmisionCR) => {
    return {
        tarjeta: data.cardNumber,
        tipoTarjeta: data.cardType,
        correo: data.insuredMail,
        celular: data.insuredPhonNumber,
        asegurado: data.insuredName,
        vencimiento: data.cardExpirationDate,
        poliza: data.cnpoliza,
        transactionId: data.transactionId,
        titularTarjeta: data.cardName,
        acepta: true,
        bancoEmisor: data.issuingBank
    }
}

const GetCurrecyPV = (currencyPlan: string) => ((currencyPlan.trim() === 'U$') ? 'U$' : '¢')

const buildDataNotification = async (pol: IAutoEmisionCR, type: typeNotificationAutoEmisionCR) => {

    let data = {
        idPoliza: pol.idPol,
        idOportunidad: '',
        nombre: pol.insuredName,
        correo: pol.insuredMail,
        celular: pol.insuredPhonNumber,
        tipoNotificacion: type
    }
    let attach = [] as Array<any>;
    switch (type) {
        case 'DocumentoIdentidad':
            if (pol.identificationFrontImage !== undefined) {
                if (pol.identificationFrontImage[0] !== undefined) {
                    attach.push(await CreateNewFile(pol.identificationFrontImage[0]))
                }
            }
            if (pol.identificationBackImage !== undefined) {
                if (pol.identificationBackImage[0] !== undefined) {
                    attach.push(await CreateNewFile(pol.identificationBackImage[0]))
                }

            }
            break;
        case 'FacturaEquiposEspeciales':
            if (pol.specialEquipmentFile !== undefined) {
                if (pol.specialEquipmentFile.length > 0) {
                    for (let i = 0; i < pol.specialEquipmentFile.length; i++) {
                        if (pol.specialEquipmentFile[`${i}`] !== null)
                            attach.push(await CreateNewFile(pol.specialEquipmentFile[`${i}`]));
                    }
                }
            }
            break;
        case 'InspeccionVehiculo':
            if (pol.frontCarImage !== undefined) {
                if (pol.frontCarImage.length > 0) {
                    for (let i = 0; i < pol.frontCarImage.length; i++) {
                        if (pol.frontCarImage[`${i}`] !== null)
                            attach.push(await CreateNewFile(pol.frontCarImage[`${i}`]));
                    }
                }
            }
            if (pol.backCarImage !== undefined) {
                if (pol.backCarImage.length > 0) {
                    for (let i = 0; i < pol.backCarImage.length; i++) {
                        if (pol.backCarImage[`${i}`] !== null)
                            attach.push(await CreateNewFile(pol.backCarImage[`${i}`]));
                    }
                }
            }
            if (pol.rightSideCarImage !== undefined) {
                if (pol.rightSideCarImage.length > 0) {
                    for (let i = 0; i < pol.rightSideCarImage.length; i++) {
                        if (pol.rightSideCarImage[`${i}`] !== null)
                            attach.push(await CreateNewFile(pol.rightSideCarImage[`${i}`]));
                    }
                }
            }
            if (pol.leftSideCarImage !== undefined) {
                if (pol.leftSideCarImage.length > 0) {
                    for (let i = 0; i < pol.leftSideCarImage.length; i++) {
                        if (pol.leftSideCarImage[`${i}`] !== null)
                            attach.push(await CreateNewFile(pol.leftSideCarImage[`${i}`]));
                    }
                }
            }
            if (pol.carPanelImage !== undefined) {
                if (pol.carPanelImage.length > 0) {
                    for (let i = 0; i < pol.carPanelImage.length; i++) {
                        if (pol.carPanelImage[`${i}`] !== null)
                            attach.push(await CreateNewFile(pol.carPanelImage[`${i}`]));
                    }
                }
            }
            break;
        case 'FacturaProforma':
            if (pol.invoiceFile !== undefined) {
                if (pol.invoiceFile.length > 0) {
                    for (let i = 0; i < pol.invoiceFile.length; i++) {
                        if (pol.invoiceFile[`${i}`] !== null)
                            attach.push(await CreateNewFile(pol.invoiceFile[`${i}`]));
                    }
                }
            }
            break;
        default:
            break;
    }

    return {
        polInfo: data,
        attach: attach
    };
}



const ResizeFile = async (file: any) => {
    return new Promise((resolve) => {
        new Compressor(file, {
            quality: 0.6,
            success(result) {
                resolve(result);
            },
            error(r) {
                console.log(r)
            }
        });
    });

}

const CreateNewFile = async (file: any) => {
    const newFile: any = await ResizeFile(file)
    const newFile2 = new File([newFile], newFile.name, { lastModified: newFile.lastModified, type: newFile.type });
    return newFile2
}

const BuildDataCICAC = (data: IAutoEmisionCR) => {
    let motivoAceptacion = '';

    if (data.cICACQuestion1 === 'N') {
        let cat = catCICACReasonRejection.find(x => x.value === data.cICACReasonRejection);
        if (cat !== undefined)
            motivoAceptacion = cat.text;
    }
    return {
        enteId: data.ente,
        acepta: data.cICACQuestion1 === 'S' ? true : false,
        idMotivoNoAceptacion: data.cICACReasonRejection === '' ? 0 : data.cICACReasonRejection,
        motivoNoAceptacion: motivoAceptacion
    }
}

const BuildDataKycNatural = (data: IAutoEmisionCR) => {
    return {
        enteId: data.ente,
        nombresConyuge: data.spouseName,
        apellidoConyuge: data.spouseLastName,
        profesionConyuge: data.spouseProfession,
        tipoIdConyuge: data.spouseIdentificationType,
        numIdConyuge: data.spouseIdentification,
        fechaNacimientoConyuge: data.spouseBirthdate,
        celularConyuge: data.spousePhoneNumber,
        paisOrigenConyuge: data.spouseCountryOrigin,
        lugarNacConyuge: data.spouseBirthPlace,
        sugef: data.obligatedSubjectsPEPQuestion1 === 'S' ? true : false,
        pep: data.obligatedSubjectsPEPQuestion2 === 'S' ? true : false,
    }
}

const Limit = (val: string, max: string) => {
    if (val.length === 1 && val[0] > max[0])
        val = '0' + val;

    if (val.length === 2) {
        if (Number(val) === 0)
            val = '01';
        else if (val > max)
            val = max;
    }
    return val;
}

const CardExpiry = (val: string) => {
    let month = Limit(val.substring(0, 2), '12');
    let year = val.substring(2, 4);
    return month + (year.length ? '/' + year : '');
}

const DataBuildNotification = async (data: IAutoEmisionCR, idSitio: number, code: string, files?: Array<File>) => {

    let dataNotification = { sitio: idSitio, codigo: code, values: {}, adjuntos: [] as Array<IFileDto> }

    let nationality = data.catNationality.find(x => x.value.toString() === data.nationality.toString());
    let profession = data.catProfesion.find(x => x.value.toString() === data.profession.toString())

    const values: Record<string, string> = {
        'interno': 'true',
        'cuserCorreduria': data.idbrokerage.toString(),
        '{{oferta}}': data.idPol.toString(),
        '{{nombres}}': data.insuredName,
        '{{identificacion}}': data.identification,
        '{{correoasegurado}}': data.insuredMail,
        '{{celular}}': data.insuredPhonNumber,
        '{{nacionalidad}}': nationality?.text ?? '',
        '{{moneda}}': data.currencyPlan,
        '{{modelo}}': data.vehicleModel,
        '{{marca}}': data.vehicleBrand,
        '{{anio}}': data.vehicleYear,
        '{{profesion}}': profession?.text ?? '',
    }

    let lst: Array<IFileDto> = [];
    if (files !== undefined) {
        if (files.length > 0) {
            for (const file of files) {
                let newFile: IFileDto = await CompressFiles(file, file.name)
                lst.push(newFile)
            }
        }
    }
    dataNotification.adjuntos = lst;
    dataNotification.values = values;
    return dataNotification;
}

const DataBuildNotificationPol = (data: IAutoEmisionCR, idSitio: number, code: string) => {
    let dataNotification = { sitio: idSitio, codigo: code, values: {}, adjuntos: [] as Array<IFileDto> }

    const values: Record<string, string> = {
        'correo': data.insuredMail,
        "idpoliza": data.idPol.toString(),
        "tiporeporte": 'pol',
        "nombrereporte": `Poliza ${data.cnpoliza}`,
        '{{nombres}}': data.insuredName,
        '{{poliza}}': data.cnpoliza
    }
    dataNotification.values = values;
    return dataNotification;
}


const DataBuildFileToPol = async (files: Array<File>, idPol: number) => {
    let data = {
        IdPoliza : idPol,
        Adjuntos: [] as any
    }
    let lstFiles = [];
    for (const file of files) {
        //let newFile: IFileDto = await CompressFiles2(file, `${GetNewGuid(1)}_${file.name}`  )
        let newFile: IFileDto = await CompressFiles2(file, `${file.name}`  )
        lstFiles.push(newFile)
    }
    data.Adjuntos = lstFiles;
    return data;
}


const CompressFiles = async (file: File, nameFile: string) => {

    let promiseCompress = new Promise((resolve) => {
        new Compressor(file, {
            quality: 0.6,
            success(result) {
                resolve(result);
            }
        });
    })

    let data: IFileDto = {} as IFileDto

    await promiseCompress.then(async (x: any) => {

        let promiseBase64 = new Promise((resolve, reject) => {

            let reader = new FileReader();
            reader.readAsDataURL(x);
            reader.onload = () => {
                resolve(reader.result);
            };
        })

        let extArray = file.name.split('.');
        let ext = extArray[extArray.length - 1];

        await promiseBase64.then((resultBase64) => {
            data = {
                Nombre: `${nameFile}.${ext}`,
                AdjuntoBase64: resultBase64,
                Peso: x.size,
                Tipo: file.type,
                UltimaModificacion: new Date(file.lastModified),
                TipoDocumento: 0
            } as IFileDto
        }).catch(error => console.log(error));

    }).catch(error => console.log(error))

    return data;
}


const CompressFiles2 = async (file: File, nameFile: string) => {

    let promiseCompress = new Promise((resolve) => {
        new Compressor(file, {
            quality: 0.6,
            success(result) {
                resolve(result);
            }
        });
    })

    let data: IFileDto = {} as IFileDto

    await promiseCompress.then(async (x: any) => {

        let promiseBase64 = new Promise((resolve, reject) => {

            let reader = new FileReader();
            reader.readAsDataURL(x);
            reader.onload = () => {
                resolve(reader.result);
            };
        })

        let extArray = file.name.split('.');
        let ext = extArray[extArray.length - 1];

        await promiseBase64.then((resultBase64: any) => {
            const base64 = resultBase64.split(';base64,');
            data = {
                Nombre: `${GetNewGuid(1)}.${ext}`,
                AdjuntoBase64: base64[1],
                Peso: x.size,
                Tipo: file.type,
                UltimaModificacion: new Date(file.lastModified),
                TipoDocumento: 0
            } as IFileDto
        }).catch(error => console.log(error));

    }).catch(error => console.log(error))

    return data;
}

export {
    GetNewGuid,
    ValidData,
    GetDataEnte,
    BuilDataToUpdate,
    RoundToTwo,
    BuildPayment,
    GetCurrecyPV,
    BuildSaveCard,
    buildDataNotification,
    BuildDataCICAC,
    BuildDataKycNatural,
    CardExpiry,
    DataBuildNotification,
    DataBuildNotificationPol,
    DataBuildFileToPol
}